import { forwardRef, useEffect, useRef } from 'react';

export default forwardRef(function TextInput({ type = 'text', className = '', isFocused = false, ...props }, ref) {
    const input = ref ? ref : useRef();

    useEffect(() => {
        if (isFocused) {
            input.current.focus();
        }
    }, [isFocused]); // Add isFocused to the dependency array

    return (
        <input
            {...props}
            type={type}
            className={
                'w-full border-gray-300 text-sm focus:border-violet-400 focus:ring focus:ring-violet-100 rounded-md ' +
                className
            }
            ref={input}
        />
    );
});